<template>
  <div class="base-container" style="background: #fff">
    <div class="logo-container">
      <div class="logo">
        <p class="logoZH">{{ logoZH }}</p>
        <p class="logoEN">
          {{ logoEN }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logoZH: global.CONFIG.logoZH,
      logoEN: global.CONFIG.logoEN,
    };
  },
};
</script>
<style lang="less">
.logo-container {
  padding-left: 48px;
  background-repeat: no-repeat;
  background-position: center left;
  background-image: url("./../../../assets/default/img/logo2.png");
  height: 24px;
  background-size: 100% 100%;
  .logo-container {
    height: 113px;
    width: 300px;
    margin: 0 auto;
    height: 114px;
    display: flex;
    align-items: center;
    img {
      height: 54px;
      margin-right: 34px;
      max-width: 100%;
    }
  }
}
.logo {
  text-align: left;
  position: relative;
  top: -3px;
  .logoZH {
    font-size: 15px;
    font-weight: bold;
    color: #005492;
    letter-spacing: 1px;
    margin: 0;
    display: flex;
    flex-direction: column;
  }
  .logoEN {
    font-size: 7px;
    font-weight: bold;
    position: relative;
    top: -6px;
    left: -50px;
    color: #005492;
    -webkit-transform: scale(0.5) !important;
    white-space: nowrap;
  }
}
</style>
